export default "__VITE_ASSET__BG5dz7vk__"